import React from 'react';
import {Button} from 'react-bootstrap';
import {FmlxIcon} from 'fmlx-common-ui';

export const ExportToExcel = ({label, isLoading, onExcelClick, icon, variant}) => {
  // const fileType =
  //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  // const fileExtension = ".xlsx";

  // const exportToCSV = (apiData, fileName) => {
  //   const ws = XLSX.utils.json_to_sheet(apiData);
  //   const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: fileType });
  //   FileSaver.saveAs(data, fileName + fileExtension);
  // };

  const onClick = () => {
    onExcelClick();
  };

  return (
    <Button disabled={isLoading} style={{width: '100%'}} variant={variant} onClick={onClick}>
      {isLoading ? (
        <div>
          <span
            style={{marginLeft: '0px'}}
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <>
          {label} <FmlxIcon name={icon} customColor={'#fafafa'}/>
        </>
      )}
    </Button>
  );
};
